.psdWrapper {
    background: #eee;
    box-shadow: inset 0 0 0 1px var(--active-highlight-color);
    margin: 0 -20px;
    padding: 20px;
}

:global(.kl-theme-dark) {
    .psdWrapper {
        background: #484848;
        box-shadow: inset 0 0 0 1px #9b9b9b;
    }
}
